import { GoogleOAuthProvider } from "@react-oauth/google";
import { FC, PropsWithChildren } from "react";

import { env } from "@/env";

const GoogleAuthProvider: FC<PropsWithChildren> = ({ children }) => {
  return <GoogleOAuthProvider clientId={env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider>;
};

export { GoogleAuthProvider };
